import React from "react"
import { PrimaryButtonType } from "../../types"
import { useAccessibility } from "../../context/AccessibilityContext"
import IconButton from "./IconButton"
import { speakOutLoud } from "../../services/functions"

export default function PrimaryButton(props: PrimaryButtonType) {
    const { getCursorPointerClass } = useAccessibility()

    return (
        <div className={`flex gap-4 items-center w-full sm:w-fit ${props.fullWidth && "sm:!w-full"}`}>
            <button
                type={props.type ?? "button"}
                onClick={props.onClick}
                disabled={props.disabled ?? false}
                className={`${
                    props?.active ? "flex" : "hidden"
                } py-2 flex items-center justify-center px-14 bg-secondary normal-case text-accent font-normal w-fit tracking-wide rounded-full text-base ${
                    props?.classProps
                } ${getCursorPointerClass()}`}>
                {props.text}
            </button>
            <IconButton
                function={() => speakOutLoud(props.text)}
                classProps={`${props?.active ? "" : "hidden"} ${props.soundHidden ? "hidden" : ""}`}
            />
        </div>
    )
}
